import axios from '../../utils/axios';
import CRUD from './crud'

const tournamentParticipantPayments = new CRUD('tournament-participant-payments', 'superior-judge')

export default Object.assign(
    tournamentParticipantPayments,
    {
        reducers: {
            ...tournamentParticipantPayments.reducers
        },


        approve: (id) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-participant-payments/${id}/approve`)
                } catch (error) {
                    console.error(error);
                }
            };
        },

        decline: (id, message=null) => {
            return async (dispatch) => {
                try {
                    return axios.post(`/superior-judge/tournament-participant-payments/${id}/decline`, {
                        message
                    })
                } catch (error) {
                    console.error(error);
                }
            };
        },

        delete: (id) => {
            return async (dispatch) => {
                try {
                    return axios.delete(`/superior-judge/tournament-participant-payments/${id}/delete`)
                } catch (error) {
                    console.error(error);
                }
            };
        },
    }
)
